export default __webpack_public_path__ + "static/media/plain.35ab34fb.svg";